import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';

export const useLocationSearchParameters = () => {
  const { search } = useLocation();

  return useMemo(() => queryString.parse(search), [search]);
};
